import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import localize from "../../../../common/localize";

export default function DynamicFormFieldImageThumbnail({
  fieldValueId,
  disabled,
  buttonStyle,
  onOpen,
}) {
  const { DYNAMIC_FORM_FIELD_VALUE_ENDPOINT, config } = useGlobalContext();
  const [imageUrl, setImageUrl] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl;
    const download = async () => {
      if (!fieldValueId || fieldValueId <= 0) {
        setImageUrl(undefined);
        return;
      }
      setLoading(true);
      try {
        const res = await axios({
          ...config,
          method: "get",
          responseType: "blob",
          url: `${DYNAMIC_FORM_FIELD_VALUE_ENDPOINT}/field/${fieldValueId}/download/false`,
        });
        objectUrl = URL.createObjectURL(res.data);
        if (active) {
          setImageUrl(objectUrl);
        }
      } catch {
        if (active) {
          setImageUrl(undefined);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };
    download();
    return () => {
      active = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
    // eslint-disable-next-line
  }, [fieldValueId]);

  // Once the image is downloaded, show the thumbnail and hide the button.
  if (imageUrl && !loading) {
    return (
      <Box sx={{ marginLeft: buttonStyle?.marginLeft ?? "15px", marginRight: "5px" }}>
        <img
          src={imageUrl}
          alt={localize.view_image}
          onClick={() => onOpen && onOpen()}
          style={{
            cursor: "pointer",
            maxHeight: "110px",
            maxWidth: "160px",
            objectFit: "contain",
            borderRadius: "6px",
            border: "1px solid #E2E8F0",
          }}
        />
      </Box>
    );
  }

  // While downloading (or if no image / download failed), keep the button.
  return (
    <Button
      disabled={disabled || loading}
      className="w-full"
      color="primary"
      variant="outlined"
      onClick={() => onOpen && onOpen()}
      style={buttonStyle}
    >
      {localize.view_image}
    </Button>
  );
}
